var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.debug)?_c('div',[_c('b-button',{on:{"click":_vm.addToast}},[_vm._v("Show toast")]),_c('b-button',{on:{"click":_vm.deleteToast}},[_vm._v("Delete toast")])],1):_vm._e(),_vm._l((_vm.toasts),function(data){return _c('div',{key:data.id + 'parent'},[_c('ProgressToast',{attrs:{"data":data}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }